import { Component, Input, HostListener, ElementRef } from '@angular/core';
import { ProvidersService, ParentBusiness } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { FcEvent } from '../business/fcevent.event';
/**
 * fc-navsideä¾§è¾¹æ å¯¼èª
 * 
 * ä¾§è¾¹æ å¯¼èªã
 * 
 * å¦è¾¹æ æ¾ç¤ºå¨é¨æ¶æ¯ãå·²è¯»æ¶æ¯ãæªè¯»æ¶æ¯æ¶ã
 * 
 * äºä»¶
 * 
 * 1.ç¹å»äºä»¶ï¼click
 * 
 * 2.å¼å³äºä»¶ï¼toggle
 * 
 */
@Component({
    selector: 'fc-navside',
    template: `
    <div class="fc-navside" 
    [ngClass]="{'fc-navside-opened':fcStatus==='opened','fc-navside-closed':fcStatus==='closed','fc-navside-small':fcSize==='small','fc-navside-default':fcSize==='default','fc-navside-large':fcSize==='large'}">
        <nz-tabset>
            <nz-tab [nzTitle]="fcLabelCode1Template">
                <ng-template #fcLabelCode1Template>
                    {{fcOption.fcLabelCode1}}
                </ng-template>
                <ul>
                    <li class="tab-content" *ngFor="let item of fcOption.fcValues1" (click)="_event(fcevent.fcnavsideClick,item);"
                    [ngClass]="{'blue':item[fcOption.fcColorCode]==='normal','yellow':item[fcOption.fcColorCode]==='waring','red':item[fcOption.fcColorCode]==='danger','fc-isread':item[fcOption.fcReadCode]==='Y','fc-noread':item[fcOption.fcReadCode]==='N'}">
                        <i nz-icon iconfont="fc-icon-chat"></i>
                        <div class="main-content">
                            <h3 class="fc-title">{{item[fcOption.fcTitleCode]}}</h3>
                            <p class="fc-smark">{{item[fcOption.fcSmarkCode]}}</p>
                            <p class="fc-time">{{item[fcOption.fcTimeCode]}}</p>
                        </div>
                    </li>
                </ul>
            </nz-tab>
            <nz-tab [nzTitle]="fcLabelCode2Template">
                <ng-template #fcLabelCode2Template>
                    {{fcOption.fcLabelCode2}}
                </ng-template>
                <ul>
                    <li class="tab-content" *ngFor="let item of fcOption.fcValues2" (click)="_event(fcevent.fcnavsideClick,item);"
                    [ngClass]="{'blue':item[fcOption.fcColorCode]==='normal','yellow':item[fcOption.fcColorCode]==='waring','red':item[fcOption.fcColorCode]==='danger','fc-isread':item[fcOption.fcReadCode]==='Y','fc-noread':item[fcOption.fcReadCode]==='N'}">
                    <i nz-icon iconfont="fc-icon-chat"></i>
                        <div class="main-content">
                            <h3 class="fc-title">{{item[fcOption.fcTitleCode]}}</h3>
                            <p class="fc-smark">{{item[fcOption.fcSmarkCode]}}</p>
                            <p class="fc-time">{{item[fcOption.fcTimeCode]}}</p>
                        </div>
                    </li>
                </ul>
            </nz-tab>
        </nz-tabset>
    </div>
    `,
    styles: [`
    .fc-navside {
        width:0px;
        height:calc(100% - 50px);
        background-color:#ffffff;
        box-shadow: 0 8px 10px -5px rgba(0,0,0,.2), 0 16px 24px 2px rgba(0,0,0,.14), 0 6px 30px 5px rgba(0,0,0,.12);
        position:absolute;
        z-index:3;
        transition:transform .3s ease-out;
        visibility: hidden;
        right:0;
        top:50px;
        transform:translate3d(300px,0px,0px);
        display: block;
    }
    .fc-navside-opened {
        width:300px;
        transform: translate3d(0px, 0px, 0px);
        visibility: visible;
    }
    .fc-navside-closed {
        width:0;
        transform:translate3d(300px,0px,0px);
    }
    .message-tips {
        font-size:18px;
        width:30px;
        flex-shrink: 0;
        display: inline-block;
        padding-top:5px; 
    }
    .main-content {
        width:calc(100% - 30px);
        flex-grow: 1;
        margin-left:25px;
    }
    .yellow .message-tips {
        color:#ffbf00;
    }
    .red .message-tips {
        color:#f04134;
    }
    .blue .message-tips {
        color:#108ee9;
    }
    :host ::ng-deep nz-tabset {
        height:100%;
    }
    :host ::ng-deep .nt-tabs-nav {
        width:100%;
    }
    :host ::ng-deep .ant-tabs-nav .ant-tabs-tab {
        margin-right:0;
    }
    :host ::ng-deep .ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content {
        height: calc(100% - 40px);
    }
    :host ::ng-deep .ant-tabs-tab {
        width:50%;
        text-align:center;
    }
    :host ::ng-deep .ant-tabs-tabpane {
        height:calc(100%-32px);
        overflow:auto;
    }
    .tab-content {
        padding:10px 10px;
        display: flex;
        cursor:pointer;
    }
    .tab-content:hover {
        background-color:#ecf6fd;
    }
    .fc-title{
        width:100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
    }
    .fc-smark {
        width:100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .fc-isread .fc-title{
        color: #666;
        font-weight: normal;
    }
    .fc-noread .fc-title,.fc-noread .fc-smark,.fc-noread .fc-time{
        color:#333;
        font-weight: bold;
    }
    :host ::ng-deep .ant-tabs-bar {
        margin-bottom: 0px;
    }
    :host ::ng-deep .ant-tabs-content-animated{
        padding-top:16px;
    }
    :host ::ng-deep .ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content{
        height:88%;
    }
    `]
})
export class FcnavsideComponent extends FcinputComponent {
    fcevent = FcEvent.fcnavside;
    /**éç½®*/
    @Input()
    fcOption: NavsideOptions;
    constructor(public provider: ProvidersService, private elementRef: ElementRef) {
        super(provider, 'fc-navside');
    }
    /**
     * ç¹å»ä¾§è¾¹æ å¤çåºåå³é­
     */
    @HostListener('document:click', ['$event']) _onOutsideClick(event: any): void {
        var clickedEl = event.target;
        var classList = clickedEl.classList;
        var parentElement = clickedEl.parentElement;
        if (parentElement) {
            var grantElement = parentElement.parentElement;
            if (grantElement) {
                classList = grantElement.classList;
            }
        }
        /**ç¹å»çåºåä¸åæ¬æ­¤ç»ä»¶æ¬èº«ä¸ä¸åå«é¡¶é¨å·¥å·æ çæ¶æ¯æé®*/
        if (!this.elementRef.nativeElement.contains(event.target) && !classList.contains('toolbar-control-message')) {
            this._event(this.fcevent.fcnavsideClick, null);
        }
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        if (this.fcOption.fcLabelCode1 === undefined) {
            throw new Error("ç¼ºå°fcLabelCode1åæ°");
        }
    }
    _event(eventName, param): void {
        switch (eventName) {
            //å³é­ä¾§è¾¹æ 
            case this.fcevent.fcnavsideClick:
                if (param !== null) {
                    super.event(FcEvent.fcnavside.fcnavsideClick, param);
                    this.fcOption.fcValues1 = Object.assign([], this.fcOption.fcValues1.filter(item => item.ID !== param.ID));
                    let obj = Object.assign({ ISREAD: 'Y', WHERE: "{ID:{eq:'" + param.ID + "'}}" }, param);
                    this.pushDestroy(ParentBusiness.appService.updateObject("SYSMESSAGE", obj).subscribe());
                }
                this.fcStatus = 'closed';
                super.event(FcEvent.fcnavside.fcnavsideToggle, this.fcStatus);
                break;
        }
    }
}
export interface NavsideOptions {
    /**åæ°æ®id*/
    fcAppid?: string,
    /**æ¾ç¤ºç¬¬ä¸ä¸ªéé¡¹å¡*/
    fcLabelCode1?: string,
    /**æ¾ç¤ºç¬¬äºä¸ªéé¡¹å¡*/
    fcLabelCode2?: string,
    /**æ é¢*/
    fcTitleCode?: string,
    /**æè¿°*/
    fcSmarkCode?: string,
    /**é¢è²*/
    fcColorCode?: string,
    /**æ¶é´*/
    fcTimeCode?: string;
    /**æ¯å¦å·²è¯»*/
    fcReadCode?: string,
    fcValues1?: any[],
    fcValues2?: any[]
}